import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom'
import TreeView from './View/TreeView';



const styles = theme => ({

})

class TreeLanding extends Component {
    render() {
        return (
            <div>

                <Switch>
                    <Route exact path="/registration" render={(props) =>
                        <TreeView
                            {...props}
                            history={this.props.history}
                            username={this.props.username}
                            apikey={this.props.apikey} />
                    } />
                </Switch>
            </div>
        )
    }
}

export default withStyles(styles)(TreeLanding)